import React from "react";
import { createUseStyles } from "react-jss";
import BodyText from "../components/Typography/BodyText.js";
import SubHeading from "../components/Typography/SubHeading.js";
import Photo1 from "../../src/assets/img/Photo1.jpg";
import Photo2 from "../../src/assets/img/Photo2.jpg";
import Photo3 from "../../src/assets/img/Photo3.jpg";
import Photo4 from "../../src/assets/img/Photo4.jpg";
import Photo5 from "../../src/assets/img/Photo5.jpg";
import Photo6 from "../../src/assets/img/Photo6.jpg";
import Photo7 from "../../src/assets/img/Photo7.jpg";
import Photo8 from "../../src/assets/img/Photo8.jpg";
import Photo9 from "../../src/assets/img/Photo9.jpg";

const useStyles = createUseStyles((theme) => {
	return {
		pageContainer: {
			padding: "32px 24px 32px 24px",
			width: "100%",
		},
		gallery: {
			width: "100%",
			display: "flex",
			flexWrap: "wrap",
		},
		image: {
			maxWidth: "154px",
			flex: "auto",
			margin: "8px",
			borderRadius: "8px",
			"@media (min-width: 769px)": {
				maxWidth: "228px",
			},
		},
		aboutText: {
			display: "flex",
			flexDirection: "column",
			gap: "16px",
			"@media (min-width: 769px)": {
				filter: "saturate(0)",
			},
			"&:hover": {
				filter: "saturate(100%)",
				transition: "all 0.5s ease-out",
			},
		},
		link: {
			color: theme.textStrong,
			textDecoration: "underline",
		},
	};
});

const Experience = () => {
	const classes = useStyles();
	return (
		<div data-testid="experience" className={classes.pageContainer}>
			<SubHeading level={2} title="About" />
			<div className={classes.aboutText}>
				<div className={classes.col}>
					<BodyText size="xxs">MY PHILOSOPHY</BodyText>
					<BodyText size="xs">
						My love for art and problem solving led me to a career in
						technology. In both engineering and design, I've carried the same
						philosophy: Keep it simple. To me this means starting with
						understanding the customers and their problems, and identifying
						universal or existing patterns to solve the problem before
						considering anything else.
					</BodyText>
					<br />
					<BodyText size="xxs">WHAT I DO</BodyText>
					<BodyText size="xs">
						Currently, I lead the Product Design team at NinjaOne. Prior to
						switching to management, I was Principal Product Designer focused on
						0->1 products, platform redesigns, design system standardization and
						helping define the vision for generative and agentic AI within our
						platform.
					</BodyText>
					<br />
					<BodyText size="xxs">OUTSIDE OF WORK</BodyText>
					<BodyText size="xs">
						When I’m not working, I do my best to stay off screens by practicing
						pottery, painting, baking, golfing, or taking my dog to the beach.
						<br />
						<br />
						---
						<br />
						<br />
						Thanks for stopping by!
						<br />
						Got any questions or looking for mentorship?{" "}
						<a
							className={classes.link}
							href="https://www.linkedin.com/in/lcrubio">
							Let's connect.
						</a>
					</BodyText>
				</div>
				<div className={classes.gallery}>
					<img className={classes.image} src={Photo1} alt="beach" />
					<img className={classes.image} src={Photo2} alt="vineyard" />
					<img className={classes.image} src={Photo3} alt="vineyard" />
					<img className={classes.image} src={Photo4} alt="vineyard" />
					<img className={classes.image} src={Photo5} alt="vineyard" />
					<img className={classes.image} src={Photo6} alt="vineyard" />
					<img className={classes.image} src={Photo9} alt="vineyard" />
					<img className={classes.image} src={Photo8} alt="vineyard" />
					<img className={classes.image} src={Photo7} alt="vineyard" />
				</div>
			</div>
		</div>
	);
};

export default Experience;
